import "temporal-polyfill/global";
import { createApp } from "vue";
import { createPinia } from "pinia";
import { initialiseModules } from "@/modules";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import PrimeVue from "primevue/config";
import ToastService from "primevue/toastservice";
import ConfirmationService from "primevue/confirmationservice";
import Tooltip from "primevue/tooltip";
import Button from "primevue/button";
import AppCard from "@/shared/components/AppCard.vue";
import App from "./App.vue";
import router from "./router";
import "./assets/base.css";
import mixpanel from "mixpanel-browser";
import {
  SENTRY_DSN,
  SENTRY_ENV,
  MIXPANEL_TOKEN,
  RELEASE_VERSION,
} from "@/shared/utils/env";
import * as Sentry from "@sentry/vue";
import { replayIntegration } from "@sentry/vue";
import Aura from "./assets/presets/aura";
import Keyfilter from "primevue/keyfilter";

const app = createApp(App);
const pinia = createPinia();

if (MIXPANEL_TOKEN) {
  mixpanel.init(MIXPANEL_TOKEN);
}

Sentry.init({
  app,
  dsn: SENTRY_DSN,
  environment: SENTRY_ENV,
  release: RELEASE_VERSION,
  integrations: [replayIntegration()],
  tracesSampleRate: 0.0,
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 1.0,
});

initialiseModules({ router });
pinia.use(piniaPluginPersistedstate);
app.use(PrimeVue, { unstyled: true, pt: Aura });
app.use(ToastService);
app.use(ConfirmationService);
app.directive("tooltip", Tooltip);
app.directive("keyfilter", Keyfilter);
app.use(pinia);
app.component("AppButton", Button);
app.component("AppCard", AppCard);
app.use(router);
app.mount("#app");

// this must be after pinia is used above
import { useAuthStore } from "@/modules/auth/stores/auth";
const { loggedInUserId } = useAuthStore();
Sentry.setTag("loggedInUserId", loggedInUserId);
